/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { ENTITY_ID } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import type { JiraLinkConfig } from '@jira/platform__routing-router-components/src/ui/router-link-config/index.tsx';
import FilterIcon from '@atlaskit/icon/core/filter';
import { FILTER_HREF } from '../../constants.tsx';

type SimpleFilterMenuItemProps = {
	actionsOnHover?: React.ReactNode;
	filterId: string;
	name: string;
	onClick: () => void;
};

export function SimpleFilterMenuItem({
	actionsOnHover,
	filterId,
	name,
	onClick,
}: SimpleFilterMenuItemProps): React.JSX.Element {
	return (
		<Nav4MenuLinkItem<JiraLinkConfig>
			actionsOnHover={actionsOnHover}
			elemBefore={<FilterIcon label="" color="currentColor" />}
			href={FILTER_HREF(filterId)}
			// oxlint-disable-next-line react/react-compiler
			menuId={ENTITY_ID.FILTER(filterId)}
			onClick={onClick}
		>
			{name}
		</Nav4MenuLinkItem>
	);
}
